import RateAudioVideo from './RateAudioVideo';

export const formSteps = {
  1: RateAudioVideo,
};
